export { SubmitForm } from './submit-form.component';
